import { unescapeReferenceToken } from '@criteria/json-pointer'
import type { ExternalDocumentation as ExternalDocumentationV3_0 } from '@criteria/openapi/v3.0'
import type { ExternalDocumentation as ExternalDocumentationV3_1 } from '@criteria/openapi/v3.1'
import { Change, OpenAPI } from './Change'
import { type Method } from './operation'

const defaultExternalDocumentation = { url: '' }

export type ExternalDocumentationRef = `#/externalDocs` | `#/paths/${string}/${string}/externalDocs`
export type ExternalDocumentation = ExternalDocumentationV3_0 | ExternalDocumentationV3_1

export abstract class UpdateExternalDocumentation extends Change {
  constructor(readonly ref: ExternalDocumentationRef) {
    super()
  }
  apply(document: OpenAPI): void {
    if (this.ref === '#/externalDocs') {
      document.externalDocs ??= defaultExternalDocumentation
      this.applyToExternalDocumentation(document.externalDocs)
      return
    }
    let match = this.ref.match(/^#\/paths\/(~1[^/]*)\/(get|put|post|delete|options|head|patch|trace)\/externalDocs$/)
    if (match !== null) {
      const path = unescapeReferenceToken(match[1]) as `/${string}`
      const method = match[2] as Method
      const operation = ((document.paths ?? {})[path] ?? {})[method]
      if (operation) {
        operation.externalDocs ??= defaultExternalDocumentation
        this.applyToExternalDocumentation(operation.externalDocs)
      }
    }
  }
  abstract applyToExternalDocumentation(externalDocs: ExternalDocumentation): void
}

export class UpdateExternalDocumentationURL extends UpdateExternalDocumentation {
  constructor(readonly ref: ExternalDocumentationRef, readonly value: string) {
    super(ref)
  }
  applyToExternalDocumentation(externalDocs: ExternalDocumentation): void {
    externalDocs.url = this.value
  }
}

export class UpdateExternalDocumentationDescription extends UpdateExternalDocumentation {
  constructor(readonly ref: ExternalDocumentationRef, readonly value: string) {
    super(ref)
  }
  applyToExternalDocumentation(externalDocs: ExternalDocumentation): void {
    externalDocs.description = this.value
  }
}
